import React, { memo, useMemo } from 'react'
import Empty from 'tve/components/appointment_grid/mobile/empty'
import Holiday from 'tve/components/appointment_grid/mobile/holiday'
import Slot from 'tve/components/appointment_grid/mobile/slot'
import { formatTime } from 'tve/helpers/date'

const Rows = memo(({ grid, selectedColumn, value, onChange, branchId, selectBranch }) => {
  const empty = useMemo(() => {
    grid.every((row) => {
      const slot = row[selectedColumn]
      return slot.available === false && slot.holiday === false
    })
  }, [grid, selectedColumn])

  return (
    <ul className="atp-time-list">
      {grid.map((row) => {
        const slot = row[selectedColumn]

        return slot.holiday ? (
          <Holiday key={formatTime(slot.start)} slot={slot} grid={grid} />
        ) : (
          <Slot
            key={formatTime(slot.start)}
            slot={slot}
            value={value}
            branchId={branchId}
            onChange={onChange}
            selectBranch={selectBranch}
          />
        )
      })}
      {empty && <Empty />}
    </ul>
  )
})
Rows.displayName = 'Rows'

export default Rows
